<script>
    import Icon from '../icons/Icon.svelte';

    export let groups = [];
    export let onEditGroup = (groupKey) => {};
    export let onToggleGroup = (groupKey) => {};
    export let onAddGroup = () => {};
    export let onBack = () => {};
    export let onContinue = () => {};

    $: activeCount = groups.filter(g => g.enabled).length;
</script>

<div class="groups-list-flow">
    <!-- CABEÇALHO DA ETAPA 3 -->
    <div class="step-header-text">
        <span class="step-badge">Etapa 3 de 4 · Revisão de Complementos</span>
        <h2 class="step-title">Revise os complementos do seu cardápio</h2>
        <p class="step-subtitle">
            Ative ou desative grupos e clique em <strong>Editar</strong> para personalizar preços, opções e regras de escolha.
        </p>
    </div>

    <!-- LISTA DE CARDS RESUMIDOS (SEM POLUIÇÃO DE CAMPOS) -->
    <div class="groups-cards-container">
        {#each groups as group}
            <div class="group-summary-card {!group.enabled ? 'is-disabled' : ''}">
                <div class="card-left-col">
                    <div class="toggle-wrap">
                        <input
                            type="checkbox"
                            id="toggle_{group.key}"
                            checked={group.enabled}
                            on:change={() => onToggleGroup(group.key)}
                            class="clean-checkbox"
                        />
                    </div>
                    <div class="group-details">
                        <div class="title-row">
                            <label for="toggle_{group.key}" class="group-name-label">
                                {group.name}
                            </label>
                            <span class="rule-badge {group.required ? 'is-required' : 'is-optional'}">
                                {group.required ? 'Obrigatório' : 'Opcional'} · {group.min_choice}-{group.max_choice} escolhas
                            </span>
                        </div>
                        <div class="options-preview-line">
                            <span class="options-count">{group.items ? group.items.length : 0} opções:</span>
                            <span class="options-names">
                                {group.items ? group.items.map(it => it.name).join(', ') : 'Nenhuma opção cadastrada'}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="card-right-col">
                    <button
                        type="button"
                        class="btn-edit-group"
                        on:click={() => onEditGroup(group.key)}
                        title="Editar opções e preços deste grupo"
                    >
                        <Icon name="edit" size={14} color="#475569" />
                        <span>Editar</span>
                    </button>
                </div>
            </div>
        {/each}
    </div>

    <!-- BOTÃO PARA ADICIONAR NOVO GRUPO / CATEGORIA -->
    <div class="add-group-action-row">
        <button type="button" class="btn-add-new-group" on:click={onAddGroup}>
            <Icon name="plus" size={16} color="#FF6A00" />
            <span>Adicionar nova categoria de complementos</span>
        </button>
    </div>

    <!-- BARRA INFERIOR DE AÇÕES -->
    <div class="step-footer-actions">
        <button type="button" class="btn-back" on:click={onBack}>
            <Icon name="arrow-left" size={16} color="#64748B" />
            <span>Voltar</span>
        </button>

        <button
            type="button"
            class="btn-continue-next"
            on:click={onContinue}
        >
            <span>Confirmar complementos ({activeCount} ativos)</span>
            <Icon name="arrow-right" size={16} color="#FFFFFF" />
        </button>
    </div>
</div>

<style>
    .groups-list-flow {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 820px;
        margin: 0 auto;
        width: 100%;
    }

    .step-header-text {
        text-align: left;
    }

    .step-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        color: #EA580C;
        background: #FFF7ED;
        padding: 3px 10px;
        border-radius: 6px;
        margin-bottom: 8px;
    }

    .step-title {
        font-size: 24px;
        font-weight: 800;
        color: #0F172A;
        letter-spacing: -0.4px;
        margin: 0 0 6px 0;
    }

    .step-subtitle {
        font-size: 14px;
        color: #64748B;
        margin: 0;
        line-height: 1.5;
    }

    /* CARDS RESUMIDOS */
    .groups-cards-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-height: 52vh;
        overflow-y: auto;
        padding-right: 6px;
        padding-bottom: 6px;
        scrollbar-width: thin;
        scrollbar-color: #CBD5E1 transparent;
    }

    .groups-cards-container::-webkit-scrollbar {
        width: 6px;
    }

    .groups-cards-container::-webkit-scrollbar-track {
        background: #F1F5F9;
        border-radius: 6px;
    }

    .groups-cards-container::-webkit-scrollbar-thumb {
        background: #CBD5E1;
        border-radius: 6px;
    }

    .groups-cards-container::-webkit-scrollbar-thumb:hover {
        background: #94A3B8;
    }

    .group-summary-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 16px 20px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
        transition: all 0.15s ease;
    }

    .group-summary-card:hover {
        border-color: #CBD5E1;
        box-shadow: 0 3px 8px rgba(15, 23, 42, 0.05);
    }

    .group-summary-card.is-disabled {
        opacity: 0.55;
        background: #F8FAFC;
    }

    .card-left-col {
        display: flex;
        align-items: center;
        gap: 14px;
        flex: 1;
        overflow: hidden;
    }

    .toggle-wrap {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .clean-checkbox {
        width: 18px;
        height: 18px;
        border-radius: 4px;
        border: 1.5px solid #CBD5E1;
        cursor: pointer;
        accent-color: #FF6A00;
    }

    .group-details {
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
        overflow: hidden;
    }

    .title-row {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .group-name-label {
        font-size: 15px;
        font-weight: 700;
        color: #0F172A;
        cursor: pointer;
    }

    .rule-badge {
        font-size: 11px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 6px;
    }

    .rule-badge.is-required {
        background: #FEF2F2;
        color: #B91C1C;
    }

    .rule-badge.is-optional {
        background: #F1F5F9;
        color: #475569;
    }

    .options-preview-line {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .options-count {
        font-weight: 600;
        color: #64748B;
        flex-shrink: 0;
    }

    .options-names {
        color: #94A3B8;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .card-right-col {
        flex-shrink: 0;
    }

    .btn-edit-group {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 36px;
        padding: 0 14px;
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        color: #334155;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-edit-group:hover {
        background: #FFFFFF;
        border-color: #FF6A00;
        color: #FF6A00;
    }

    /* BOTÃO NOVO GRUPO */
    .add-group-action-row {
        display: flex;
        justify-content: center;
    }

    .btn-add-new-group {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 12px 20px;
        background: #FFFFFF;
        border: 1.5px dashed #CBD5E1;
        border-radius: 10px;
        color: #334155;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        width: 100%;
        justify-content: center;
        transition: all 0.15s ease;
    }

    .btn-add-new-group:hover {
        background: #FFFBF7;
        border-color: #FF6A00;
        color: #C2410C;
    }

    /* FOOTER */
    .step-footer-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 14px;
        padding-bottom: 4px;
        border-top: 1px solid #E2E8F0;
        position: sticky;
        bottom: 0;
        background: #F8FAFC;
        z-index: 10;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 44px;
        padding: 0 16px;
        background: transparent;
        border: 1px solid #CBD5E1;
        border-radius: 10px;
        color: #475569;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-back:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .btn-continue-next {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 46px;
        padding: 0 24px;
        background: #FF6A00;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 700;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
    }

    .btn-continue-next:hover {
        background: #EA580C;
        box-shadow: 0 4px 12px rgba(255, 106, 0, 0.35);
        transform: translateY(-1px);
    }

    @media (max-width: 640px) {
        .group-summary-card {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }

        .card-right-col {
            width: 100%;
        }

        .btn-edit-group {
            width: 100%;
            justify-content: center;
        }

        .step-footer-actions {
            flex-direction: column-reverse;
            gap: 10px;
        }

        .btn-continue-next,
        .btn-back {
            width: 100%;
            justify-content: center;
        }
    }
</style>
